import React from "react";
import { Flame, Hammer, ClipboardCheck, Wrench, Construction, Settings, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Website Development",
  description: "High-performance digital experiences built for conversion and prestige. We craft bespoke websites that define your brand's authority.",
  icon: Settings,
  link: "/ServicesPage"
}, {
  title: "Social Media Management",
  description: "Data-driven strategies that amplify your voice. We handle everything from content scheduling to community engagement and growth.",
  icon: Flame,
  link: "/ServicesPage"
}, {
  title: "Branding & Identity",
  description: "Developing visual languages that resonate. We create cohesive brand identities that stand out in a saturated digital landscape.",
  icon: Hammer,
  link: "/ServicesPage"
}, {
  title: "Personal Branding",
  description: "Positioning entrepreneurs and athletes as industry leaders. We build the digital legacy behind the individual name.",
  icon: ClipboardCheck,
  link: "/ServicesPage"
}, {
  title: "Content Creation",
  description: "Cinematic short-form content designed for virality. High-end visual storytelling that captures attention in seconds.",
  icon: Construction,
  link: "/ServicesPage"
}, {
  title: "Digital Growth",
  description: "Comprehensive scaling solutions for modern businesses. We bridge the gap between creative vision and measurable ROI.",
  icon: Wrench,
  link: "/ServicesPage"
}];
export default function VoresYdelser() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="38906" id="service-cards" className="bg-background text-foreground py-[160px] relative overflow-hidden" ref={ref}>
      {}
      <div className="container mx-auto px-4 md:px-6">
        <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {services.map((service, i) => <div key={i} data-index={i} className="group relative flex flex-col bg-background/40 backdrop-blur-xl border border-white/10 p-[40px] transition-all duration-500 hover:shadow-2xl hover:border-secondary/50 rounded-lg">
              <div className="mb-6">
                <service.icon className="size-10 text-muted-foreground stroke-[1.5px] group-hover:text-secondary transition-colors duration-500" aria-hidden="true" />
              </div>

              <div className="flex-1">
                <h3 className="text-2xl font-extrabold tracking-tighter text-foreground mb-4 uppercase">
                  {service.title}
                </h3>
                <p className="text-muted-foreground leading-[1.6] mb-8 font-light text-lg">
                  {service.description}
                </p>
              </div>

              <div className="mt-auto">
                
              </div>
              
              <span className="absolute top-8 right-8 font-mono text-sm opacity-10 group-hover:opacity-30 transition-opacity duration-500">
                0{i + 1}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}